import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  IN_ROOM_DINING_TAGS_CREATE,
  IN_ROOM_DINING_TAGS_EDIT,
  IN_ROOM_DINING_TAGS_VIEW,
  IN_ROOM_DINING_SELECTED_ITEM_ALREADY_OCCUPIED_ERROR,
} from '../../../../../constants/InRoomDiningConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_SERVICES_IN_ROOM_DINING,
} from '../../../../../constants/RoleConsts';
import LinearProgressBar from '../../../../../shared/progress-bar/Progress';
import SearchBar from '../../../../../shared/search-bar/Search-Bar';
import {
  inRoomDiningTagsSelector,
  inRoomDiningItemsSelector,
  fetchAllInRoomDining,
  setInRoomDiningTags,
} from '../../../servicesSlice';
import DeletePopupModel from '../../../../../shared/delete-popup/Delete-Popup';
import { AddCircle, DragIndicator, MoreHoriz } from '@material-ui/icons';
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  TablePagination,
  Menu,
  MenuItem,
  Checkbox,
} from '@material-ui/core';
import CreateIcon from '@material-ui/icons/Create';
import VisibilityIcon from '@material-ui/icons/Visibility';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import TablePaginationActions from '../../../../../shared/table-pagination/TablePaginationActions';
import {
  activateInRoomDiningTag,
  deactivateInRoomDiningTag,
  deleteInRoomDiningTag,
  deleteSelectedItems,
  updateSelectedItemsStatus,
  uploadIRDTagByCSV,
  addInRoomDiningTag,
} from '../../../../../utils/ServicesAPIUtils';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import WarningPopup from '../../../../../shared/warning-popup/Warning-Popup';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import useOutsideAlerter from '../../../../../custom-hooks/useOutsideAlerter';
import { handleOnDragEnd } from '../../../../../shared/custom-dragdrop/dragDrop';
import { createDataSortMapping } from '../../../../../utils/PropertyAPIUtils';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import {
  getCheckedIds,
  updateCheckedStatus,
  updateSelectedModule,
  generateConfirmationMessage,
  validateAlphanumeric,
  selectedCheckList,
  ResetFilterList,
  PARTIAL_CHECKBOX_GREEN,
} from '../../../../../utils/formUtils';
import { Dialog } from '@mui/material';
import CsvUploader from '../../../../../shared/csv-uploader/Csv-Uploader';
import MultipleDeleteConfirmationPopup from '../../../../../shared/MultiActionPopUp/MultiDeleteConfirmationPopup';
import { allHotelsSelector } from '../../../../property/propertySlice';
import { stubFalse } from 'lodash';
import BulkActionCheckBox from '../../../../../shared/MultiActionPopUp/BulkActionCheckBox';
import MultipleSelectionAlert from '../../../../../shared/MultiActionPopUp/MultipleSelectionAlert';
import { decryptLocalStorage } from '../../../../../utils/authUtils';
import { DOWNLOAD_ASSETS_URL } from '../../../../../env/Configurations';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../utils/loaderSlice';

const initialState = {
  name: '',
  description: '',
  status: false,
};

const TagsListView = (props) => {
  const {
    onDrawerToggle,
    onViewToggle,
    hotelId,
    restaurantId,
    inRoomDiningLoader,
    permissions,
    page,
    rowsPerPage,
    onsetRowsPerPage,
    onsetPage,
    isHideAddButton = false,
  } = props;
  const dispatch = useDispatch();
  const inRoomDiningTags = useSelector(inRoomDiningTagsSelector);
  const inRoomDiningItems = useSelector(inRoomDiningItemsSelector);
  const [tagsList, setTagsList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedValue, setSelectedValue] = useState({
    id: '',
    name: '',
    title: '',
    description: '',
    status: false,
    anchorEl: null,
  });
  const selectedHotel = useSelector(allHotelsSelector);
  const [warningPopup, setWarningPopup] = useState(initialState);
  const [visible, setVisible] = useState(false);
  const wrapperRef = useRef(null);
  const prevHotelIdRef = useRef(hotelId);
  const [popUp, setPopUp] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [uploadState, setUploadState] = useState(false);
  const [csvUploadStatus, setCsvUploadStatus] = useState(false);
  const [csvUploadErrorMsg, setCsvUploadErrorMsg] = useState(null);
  const [csvValidateError, setCsvValidateError] = useState(false);
  const [dataExistError, setDataExistError] = useState(false);
  const [validationErrors, setValidationErrors] = useState([]);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [actionMenuList, setActionMenuList] = useState([]);
  const [isActive, setIsActive] = useState(false);
  const [showMultipleDeleteConfirmation, setShowMultipleDeleteConfirmation] = useState(false);
  const [actionName, setActionName] = useState(false);
  const [showBulkActiveDeactiveConfirmation, setShowBulkActiveDeactiveConfirmation] =
    useState(false);
  const [showBulkSearchAlert, setShowBulkSearchAlert] = useState(false);
  const [showBulkKebabSelectionAlert, setShowBulkKebabSelectionAlert] = useState(false);
  const [showBulkFilterAlert, setShowBulkFilterAlert] = useState(false);
  const dragDisabled = !!searchText || tagsList.length <= 1;

  useEffect(() => {
    setTagsList((prevList) => {
      return inRoomDiningTags?.map((item) => {
        const isChecked = selectedCheckList(prevList, item.id);
        return {
          ...item,
          isChecked: isChecked,
        };
      });
    });
    setLoading(false);
    setSearchText('');
  }, [inRoomDiningTags]);

  const handleSearchText = async (searchText) => {
    setSearchText(searchText);
    const checkedIdList = getCheckedIds(tagsList, 'isChecked');
    const filteredRows = await inRoomDiningTags.filter((tag) => {
      return tag.name.toLowerCase().includes(searchText.toLowerCase());
    });
    const updatedCheckedList = updateCheckedStatus(filteredRows, checkedIdList);
    onsetPage(0);
    setTagsList(updatedCheckedList);
    if (searchText && (isAllSelected || selectedTagsLength > 0)) {
      setShowBulkSearchAlert(true);
    } else if (!searchText) {
      setShowBulkSearchAlert(false);
      setTagsList(ResetFilterList);
    }
  };

  useEffect(() => {
    updateSelectedModule(tagsList, setActionMenuList, setIsAllSelected);
  }, [tagsList]);

  useEffect(() => {
    if (inRoomDiningLoader || tagsList?.length === 0) return;
    const totalItems = tagsList?.length;
    const maxPageIndex = Math.max(Math.ceil(totalItems / rowsPerPage) - 1, 0);
    if (page > maxPageIndex) {
      onsetPage(maxPageIndex);
    }
  }, [tagsList?.length, rowsPerPage, page, onsetPage]);

  useEffect(() => {
    if (prevHotelIdRef?.current !== hotelId) {
      onsetPage(0);
    }
    prevHotelIdRef.current = hotelId;
  }, [hotelId]);

  const onOpenDrawer = (event, type) => {
    if (selectedTagsLength) {
      setTagsList(ResetFilterList);
    }
    event.stopPropagation();
    onDrawerToggle(type, true, selectedValue.tag);
    handleClose();
  };

  const handleClose = () => {
    setSelectedValue({
      id: '',
      name: '',
      title: '',
      description: '',
      status: false,
      anchorEl: null,
      tag: null,
    });
  };

  const handleCellMenuClick = (event, tag) => {
    event.stopPropagation();
    if (selectedTagsLength > 1) {
      setShowBulkKebabSelectionAlert(true);
    } else {
      setSelectedValue({
        id: tag.id,
        name: tag.name,
        title: '',
        description: '',
        status: false,
        anchorEl: event.currentTarget,
        tag,
      });
    }
  };

  const handleChangePage = (event, newPage) => {
    onsetPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    onsetRowsPerPage(parseInt(event.target.value, 10));
    onsetPage(0);
  };

  const onClickDelete = (event) => {
    event.stopPropagation();
    if (checkUsageItems()) {
      setWarningPopup({
        name: selectedValue.name,
        description: 'The selected Tag cannot be deleted as it is being added to a Menu/Item',
        status: true,
      });
    } else {
      setSelectedValue((prev) => ({
        ...prev,
        title: 'Are you sure you want to delete',
        description: 'This action cannot be reversed',
        status: true,
        anchorEl: null,
      }));
    }
  };

  const checkUsageItems = () => {
    return inRoomDiningItems.some(
      (ird) => ird.tags && ird.tags.some((item) => item === selectedValue.id),
    );
  };

  const onCloseWarning = () => {
    handleClose();
    setWarningPopup(initialState);
  };

  const onDeleteItem = async () => {
    try {
      dispatch(stepUpLoaderCount());
      if (hotelId && selectedValue.id) {
        const selectedLanguage = decryptLocalStorage('lang');
        const language = selectedLanguage !== 'en' ? selectedLanguage : '';
        const payload = {
          id: selectedValue.id,
          hotelId: hotelId,
          restaurantId: restaurantId,
        };
        await deleteInRoomDiningTag(payload, language);
        dispatch(fetchAllInRoomDining(hotelId, restaurantId));
        notificationManager('success', 'Tag deleted successfully');
      }
      handleClose();
    } catch (e) {
      if (e.graphQLErrors) {
        switch (e.graphQLErrors[0].message) {
          case IN_ROOM_DINING_SELECTED_ITEM_ALREADY_OCCUPIED_ERROR:
            setWarningPopup({
              name: selectedValue.name,
              description: 'The selected Tag cannot be deleted as it is being added to a Menu/Item',
              status: true,
            });
            break;
          default:
            notificationManager('danger', e.graphQLErrors[0].message);
            break;
        }
      } else {
        notificationManager('danger', 'Failed to delete Tag');
      }
    } finally {
      dispatch(stepDownLoaderCount());
    }
    handleClose();
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  const onDeleteCancel = (event) => {
    handleClose();
  };

  const getNoOfItems = (tagId) => {
    const itemsWithTag = inRoomDiningItems.filter((item) => {
      return item?.tags?.includes(tagId);
    });
    return itemsWithTag.length;
  };

  const onViewDetails = () => {
    onViewToggle(IN_ROOM_DINING_TAGS_VIEW, true, selectedValue.tag);
  };

  const onClickRowViewDetails = (tagItem, e) => {
    if (e?.target?.tagName === 'TD') {
      onViewToggle(IN_ROOM_DINING_TAGS_VIEW, true, tagItem);
    }
  };

  const onToggleStatus = async (e) => {
    e.stopPropagation();
    if (selectedValue.tag && hotelId) {
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';
      try {
        dispatch(stepUpLoaderCount());
        const payload = {
          id: selectedValue.tag.id,
          hotelId: hotelId,
          restaurantId: restaurantId,
        };
        selectedValue.tag.status
          ? await deactivateInRoomDiningTag(payload, language)
          : await activateInRoomDiningTag(payload, language);
        dispatch(fetchAllInRoomDining(hotelId, restaurantId));
        notificationManager(
          'success',
          `Tag ${selectedValue.tag.status ? 'deactivated' : 'activated'} successfully`,
        );
      } catch (e) {
        if (e.graphQLErrors) {
          notificationManager('danger', e.graphQLErrors[0].message);
        } else {
          notificationManager('danger', 'Failed to update Tag status');
        }
      } finally {
        dispatch(stepDownLoaderCount());
      }
    }
    handleClose();
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  useOutsideAlerter(wrapperRef, visible, setPopUp);
  const handleUploadDialogClose = (e) => {
    dispatch(fetchAllInRoomDining(hotelId, restaurantId));
    setCsvUploadStatus(null);
    setUploadState(false);
  };
  const onClickUpload = (e) => {
    setUploadState(true);
  };

  const isValidStatus = (status) => {
    const tempStatus = status.toLowerCase().trim();
    return tempStatus === 'yes' || tempStatus === 'no';
  };

  const toStr = (v) => (v == null ? '' : String(v));

  const handleCsvFileData = (itemsLists) => {
    try {
      const isTemplateInstructionRow = (row) => {
        const values = Object.values(row).map((v) => String(v || '').toLowerCase().trim());
        const joined = values.join(' ');
        const instructionPatterns = [
          'character limit', 'mandatory', 'alphanumeric', 'alpha-numeric',
          'enter the', 'fill in', 'e.g.', 'example:', 'max characters',
          'max char', 'required field', 'this field', 'drop down', 'dropdown',
          'select from', 'free text', 'auto populate', 'auto-populate',
        ];
        if (values.some((s) => s.startsWith('*') && instructionPatterns.some((p) => s.includes(p)))) return true;
        if (instructionPatterns.filter((p) => joined.includes(p)).length >= 2) return true;
        return false;
      };
      const filteredItemList = itemsLists.filter((row) => !isTemplateInstructionRow(row));
      if (filteredItemList.length === 0) {
        setValidationErrors(['No data rows found in the uploaded file.']);
        setCsvValidateError(true);
        return;
      }
      const currentTagsList = tagsList || [];
      const databaseNames = new Set(currentTagsList.map(ch => ch?.name?.trim()?.toLowerCase()).filter(Boolean));
      const databaseCodes = new Set(currentTagsList.map(ch => ch?.code?.trim()?.toLowerCase()).filter(Boolean));

      const nameFreq = Object.create(null);
      const codeFreq = Object.create(null);

      filteredItemList.forEach(item => {
        const nK = toStr(item.tagName).trim().toLowerCase();
        const cK = toStr(item.tagCode).trim().toLowerCase();
        if (nK) nameFreq[nK] = (nameFreq[nK] || 0) + 1;
        if (cK) codeFreq[cK] = (codeFreq[cK] || 0) + 1;
      });

      const fileDupNames = new Set(Object.keys(nameFreq).filter(k => nameFreq[k] > 1));
      const fileDupCodes = new Set(Object.keys(codeFreq).filter(k => codeFreq[k] > 1));

      const errors = [];
      const newItems = [];
      filteredItemList.forEach((item) => {
        const rowNum = item.__rowNum || '?';
        const rowErrors = [];
        const tagName = toStr(item.tagName).trim();
        const tagCode = toStr(item.tagCode).trim();
        const active = toStr(item.active).trim();

        if (!tagName) {
          rowErrors.push('"Tag Name" is empty');
        } else {
          if (tagName.length > 100) rowErrors.push('"Tag Name" exceeds 100 characters');
        }
        if (!tagCode) {
          rowErrors.push('"Tag Code" is empty');
        } else {
          if (tagCode.length > 8) rowErrors.push('"Tag Code" exceeds 8 characters');
          if (!validateAlphanumeric(tagCode)) rowErrors.push('"Tag Code" must be alphanumeric');
        }
        if (active && !isValidStatus(active)) rowErrors.push('"Active" must be Yes or No');

        const nK = tagName.toLowerCase();
        const cK = tagCode.toLowerCase();
        const nameExists = nK && (databaseNames.has(nK) || fileDupNames.has(nK));
        const codeExists = cK && (databaseCodes.has(cK) || fileDupCodes.has(cK));

        if (nameExists || codeExists) {
          const reasons = [];
          if (nameExists) reasons.push(`name '${tagName}'`);
          if (codeExists) reasons.push(`code '${tagCode}'`);
          rowErrors.push(`Already exists or duplicated in file (${reasons.join(' and ')})`);
        }

        if (rowErrors.length > 0) {
          errors.push(`Row ${rowNum}: ${rowErrors.join(', ')}`);
        } else {
          newItems.push(item);
        }
      });

      if (errors.length > 0) {
        setValidationErrors(errors);
        setCsvValidateError(true);
        setDataExistError(false);
        return;
      }

      if (newItems.length > 0) {
        const listToUpload = newItems.map((item) => ({
          hotelId,
          code: toStr(item?.tagCode).trim(),
          name: toStr(item?.tagName).trim(),
          status: toStr(item?.active).trim().toUpperCase() === 'YES' ? true : false,
          restaurantId,
        }));
        setValidationErrors([]);
        setCsvValidateError(false);
        handleCsvDataSubmit(listToUpload);
      } else {
        setValidationErrors(errors);
        setCsvValidateError(true);
        setDataExistError(false);
      }
    } catch (e) {
      setValidationErrors([`Unexpected error while processing file: ${e.message}`]);
      setCsvValidateError(true);
    }
  };

  const handleCsvDataSubmit = async (payloadLists) => {
    setCsvUploadStatus('uploading');
    try {
      dispatch(stepUpLoaderCount());
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';

      for (const payload of payloadLists) {
        const individualPayload = {
          ...payload,
          customAttributes: [],
        };
        await addInRoomDiningTag(individualPayload, language);
      }

      setCsvUploadStatus('success');
    } catch (e) {
      const errMsg = e?.graphQLErrors?.[0]?.message || e?.message || 'An unexpected error occurred while uploading. Please try again.';
      setCsvUploadErrorMsg(errMsg);
      setCsvUploadStatus('server-error');
    } finally {
      dispatch(stepDownLoaderCount());
    }
  };

  const generateHeaders = [
    { label: 'Tag Name', key: 'name' },
    { label: 'Tag Code', key: 'code' },
    { label: 'Active', key: 'active' },
  ];

  const generateExportData = (itemsData) => {
    let tempList = itemsData?.map((e) => {
      return {
        ...e,
        active: e?.status ? 'YES' : 'NO',
      };
    });
    const fields = ['name', 'code', 'active'];
    return tempList.map((record) =>
      Object.fromEntries(
        Object?.entries(record)?.filter(([key, value]) =>
          fields?.includes(key) ? [key, "'" + value] : null,
        ),
      ),
    );
  };

  const getCheckedTagList = tagsList?.filter((tag) => tag?.isChecked);
  const listOfTagIds = getCheckedTagList?.map((tag) => tag.id);
  const selectedTagsLength = getCheckedTagList?.length;

  const handleExport = () => {
    let selectedValue = tagsList?.filter((tag) => tag?.isChecked);
    let exportData = [];
    let csvName = '';

    const propertyName = selectedHotel?.find((value) => value?.id === hotelId)?.name;

    if (selectedValue?.length === 1) {
      csvName = `${selectedValue[0].name}_ird_tag.csv`;
      exportData = generateExportData(selectedValue);
    } else if (selectedValue?.length > 1) {
      csvName = `${propertyName}_ird_tag.csv`;
      exportData = generateExportData(selectedValue);
    } else {
      csvName = `${propertyName}_ird_tag.csv`;
      exportData = generateExportData(tagsList);
    }

    const headers = generateHeaders?.map((header) => header?.label);
    const csvContent = [
      headers.join(','),
      ...exportData?.map((item) =>
        generateHeaders?.map((header) => item[header.key] || '').join(','),
      ),
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv' });
    const anchor = document.createElement('a');
    anchor.href = window.URL.createObjectURL(blob);
    anchor.download = csvName;

    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  };

  const handleAction = (actionName) => {
    let selectedDiscount = tagsList?.filter((tag) => tag?.isChecked);
    switch (actionName) {
      case 'Delete':
        if (selectedDiscount?.length > 0) {
          setShowMultipleDeleteConfirmation(true);
          setActionName('delete');
        }
        break;
      case 'Activate':
        if (selectedDiscount?.length > 0) {
          setShowBulkActiveDeactiveConfirmation(true);
          setActionName('activate');
          setIsActive(true);
        }
        break;
      case 'Deactivate':
        if (selectedDiscount?.length > 0) {
          setShowBulkActiveDeactiveConfirmation(true);
          setActionName('deactivate');
          setIsActive(false);
        }
        break;
      case 'Export':
        if (selectedDiscount?.length > 0) {
          handleExport();
        }
        break;
      default:
        break;
    }
  };

  const handleCheckboxChange = (id) => {
    let actionListName = [];
    let index = tagsList?.findIndex((item) => item.id === id);
    if (!tagsList[index]?.isChecked) {
      tagsList[index] = { ...tagsList[index], isChecked: true };
    } else {
      tagsList[index].isChecked = !tagsList[index]?.isChecked;
    }
    setTagsList([...tagsList]);

    let actionList = tagsList?.filter((tag) => tag?.isChecked).map((status) => status?.status);

    const checkedItems = tagsList?.filter((tag) => tag?.isChecked);

    if (checkedItems.length === 0) {
      setActionMenuList([]);
      setIsAllSelected(false);
      return;
    }

    const isActiveSelected = actionList.includes(true);
    const isInactiveSelected = actionList.includes(false);

    if (isActiveSelected && isInactiveSelected) {
      actionListName.push('Activate', 'Deactivate');
    } else if (isActiveSelected) {
      actionListName.push('Deactivate');
    } else if (isInactiveSelected) {
      actionListName.push('Activate');
    }
    if (!actionListName.includes('Export')) {
      actionListName.push('Export');
    }

    const isAllSelected = tagsList?.every((item) => item?.isChecked);
    setIsAllSelected(isAllSelected);

    setActionMenuList(actionListName);
  };

  const handleSelectAll = (event) => {
    let actionListName = [];
    const CheckedValue = event?.target?.checked;
    setIsAllSelected(CheckedValue);
    let selectedDiscountList = tagsList?.map((item) => {
      return {
        ...item,
        isChecked: CheckedValue,
      };
    });

    const isActive = selectedDiscountList?.some((tag) => tag?.status);
    const isInactive = selectedDiscountList?.some((tag) => !tag.status);

    if (isActive && !actionListName?.includes('Deactivate')) {
      actionListName.push('Deactivate');
    }
    if (isInactive && !actionListName?.includes('Activate')) {
      actionListName.push('Activate');
    }
    if (!actionListName.includes('Export')) {
      actionListName.push('Export');
    }

    setTagsList([...selectedDiscountList]);

    const sortActionMenuList = actionListName.sort((a, b) => {
      const order = { Activate: 1, Deactivate: 2, Delete: 3 };
      return order[a] - order[b];
    });

    setActionMenuList(sortActionMenuList);

    if (!event?.target?.checked && !selectedDiscountList.some((item) => item?.isChecked)) {
      setActionMenuList([]);
    }
  };
  const handleBulkSearchAlertClose = () => {
    setShowBulkSearchAlert(false);
    setSearchText('');
    setTagsList(
      inRoomDiningTags?.map((res) => ({
        ...res,
        isChecked: false,
      })),
    );
  };

  const onApiCallConfirmationNotification = generateConfirmationMessage(
    'Tag',
    listOfTagIds?.length,
    isActive,
  );

  const handleMultipleStatusChange = async () => {
    handleClose();
    setActionMenuList([]);
    try {
      dispatch(stepUpLoaderCount());
      const lang = decryptLocalStorage('lang');
      const selectedLang = lang !== 'en' ? lang : '';
      const moduleName = 'IRD_TAG';
      await updateSelectedItemsStatus(
        listOfTagIds,
        hotelId,
        selectedLang,
        moduleName,
        restaurantId,
        isActive,
        searchText.length > 0 ? false : isAllSelected,
      );
      dispatch(fetchAllInRoomDining(hotelId, restaurantId));
      notificationManager('success', onApiCallConfirmationNotification);
      setSelectedValue({
        id: '',
        name: '',
        title: '',
        description: '',
        status: false,
        activate: false,
        brand: null,
      });
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors ? e.graphQLErrors[0].message : 'The status of the Tag was not changed',
      );
    } finally {
      dispatch(stepDownLoaderCount());
    }
    setIsAllSelected(false);
  };

  const deleteMultipleSelection = async () => {
    handleClose();
    try {
      const lang = decryptLocalStorage('lang');
      const selectedLang = lang !== 'en' ? lang : '';
      const moduleName = 'IRD_TAG';
      await deleteSelectedItems(
        listOfTagIds,
        hotelId,
        selectedLang,
        moduleName,
        restaurantId,
        searchText.length > 0 ? false : isAllSelected,
      );
      dispatch(fetchAllInRoomDining(hotelId, restaurantId));
      notificationManager('success', 'Tags deleted successfully');
      setSelectedValue({
        ...selectedValue,
        id: '',
        name: '',
        title: '',
        description: '',
        status: false,
        brand: null,
      });
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors ? e.graphQLErrors[0].message : 'Failed to delete Tag',
      );
    }
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  return (
    <div className='mt-4 mb-4 group-list-container'>
      {warningPopup?.status && (
        <WarningPopup warningPopup={warningPopup} onWarningClose={onCloseWarning} />
      )}
      {selectedValue.id && selectedValue.status === true && (
        <DeletePopupModel
          deletePopUp={selectedValue}
          onDelete={onDeleteItem}
          onDeleteCancel={onDeleteCancel}
        />
      )}
      <Dialog fullScreen open={uploadState} onClose={handleUploadDialogClose}>
        <CsvUploader
          onClose={handleUploadDialogClose}
          pageTitle='Tags'
          onFileReadingComplete={(e) => handleCsvFileData(e)}
          csvUploadStatus={csvUploadStatus}
          validFormatError={csvValidateError}
          setValidFormatError={setCsvValidateError}
          dataExistError={dataExistError}
          setDataExistError={setDataExistError}
          listName='Tags'
          sectionTItle='Menu Configuration'
          csvUploadErrorMsg={csvUploadErrorMsg}
          validationErrors={validationErrors}
          setValidationErrors={setValidationErrors}
          downloadLink={DOWNLOAD_ASSETS_URL + '/cmsAssets/Menu+Configs+Tags.xlsx'}
        />
      </Dialog>
      <SearchBar
        type={IN_ROOM_DINING_TAGS_CREATE}
        buttonName='Add Tags'
        onOpenDrawer={onOpenDrawer}
        displayAddOrEdit={
          permissions[RBAC_TYPE_SERVICES_IN_ROOM_DINING] === RBAC_PERMISSION_LEVEL_FULL_ACCESS
            ? !isHideAddButton
              ? 'show'
              : 'hide'
            : 'hide'
        }
        setSearchText={handleSearchText}
        visible={visible}
        setVisible={setVisible}
        popUp={popUp}
        setPopUp={setPopUp}
        placeHolder={tagsList}
        setPlaceHolder={setTagsList}
        globalPlaceHolder={inRoomDiningTags}
        setGlobalPlaceHolder={setInRoomDiningTags}
        dispatch={dispatch}
        mappingApi={createDataSortMapping}
        displayText='In-Room dining tags'
        module='IRD_TAG'
        searchText={searchText}
        setSearch={setSearchText}
        extraSecondaryBtnDisplay={
          permissions[RBAC_TYPE_SERVICES_IN_ROOM_DINING] === RBAC_PERMISSION_LEVEL_FULL_ACCESS
        }
        extraSecondaryBtnText='Upload'
        onClickSecondaryBtn={onClickUpload}
        //temporary disable
        // exportBtn
        // exportBtnTitle="Export"
        // headers={generateHeaders}
        // exportData={generateExportData(tagsList)}
        actionMenuItems={actionMenuList ?? []}
        handleAction={handleAction ?? false}
      />
      <div ref={wrapperRef} className='row mx-2 d-flex mt-4'>
        {loading || inRoomDiningLoader ? (
          <div className='pt-4 col-md-12'>
            <LinearProgressBar />
          </div>
        ) : (
          tagsList && (
            <TableContainer>
              <Table className='list-table' aria-label='simple table'>
                <TableHead>
                  <TableRow>
                    <TableCell className={`w-5 ${dragDisabled ? '' : 'ps-5'}`}>
                      <BulkActionCheckBox
                        onChange={handleSelectAll}
                        checked={isAllSelected || false}
                        selectedLength={selectedTagsLength}
                        totalLength={inRoomDiningTags?.length}
                        inputProps={{
                          'aria-label': 'select all Tag',
                        }}
                        className={PARTIAL_CHECKBOX_GREEN}
                      />
                    </TableCell>
                    <TableCell className='w-30'>Name</TableCell>
                    <TableCell className='w-25'>Code</TableCell>
                    <TableCell className='w-20' align='center'>
                      Status
                    </TableCell>
                    <TableCell className='w-10' align='right'>
                      No of Items
                    </TableCell>
                    <TableCell align='right'></TableCell>
                  </TableRow>
                </TableHead>
                <DragDropContext
                  onDragEnd={(event) =>
                    handleOnDragEnd(
                      event,
                      setVisible,
                      tagsList,
                      setTagsList,
                      false,
                      page,
                      rowsPerPage,
                    )
                  }
                  isDropDisabled={dragDisabled}
                >
                  <Droppable droppableId='services' isDropDisabled={dragDisabled}>
                    {(provided) => (
                      <TableBody {...provided.droppableProps} ref={provided.innerRef}>
                        {(rowsPerPage > 0
                          ? tagsList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                          : tagsList
                        ).map((tagKey, i) => (
                          <Draggable
                            key={tagKey.id}
                            draggableId={tagKey.id}
                            index={i}
                            isDragDisabled={dragDisabled}
                          >
                            {(provided) => (
                              <TableRow
                                key={i}
                                className='border-white pointer'
                                onClick={(e) => {
                                  onClickRowViewDetails(tagKey, e);
                                }}
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              >
                                <TableCell className='w-12'>
                                  {!dragDisabled && (
                                    <span style={{ marginRight: 1.5 }}>
                                      <DragIndicator className='res-menu-accordion-drag' />
                                    </span>
                                  )}
                                  <Checkbox
                                    onChange={(event) => handleCheckboxChange(tagKey?.id)}
                                    checked={tagKey?.isChecked || false}
                                    inputProps={{
                                      'aria-label': `select tag ${tagKey?.id}`,
                                    }}
                                  />
                                </TableCell>
                                <TableCell className='w-30'>{tagKey?.name}</TableCell>
                                <TableCell className='w-25'>{tagKey?.code}</TableCell>
                                <TableCell className='w-20' align='center'>
                                  <div className='d-flex justify-content-center'>
                                    <div
                                      className={`${
                                        tagKey.status ? 'pill-active ' : 'pill-inactive '
                                      } pill d-flex justify-content-center align-items-center`}
                                    >
                                      <span className='ms-1'>
                                        {!tagKey.status ? 'Inactive' : 'Active'}
                                      </span>
                                    </div>
                                  </div>
                                </TableCell>
                                <TableCell className='w-10' align='right'>
                                  {getNoOfItems(tagKey?.id)}
                                </TableCell>
                                <TableCell align='right'>
                                  {permissions[RBAC_TYPE_SERVICES_IN_ROOM_DINING] ===
                                    RBAC_PERMISSION_LEVEL_FULL_ACCESS && (
                                    <Button
                                      aria-controls='simple-menu'
                                      aria-haspopup='true'
                                      onClick={(e) => {
                                        handleCellMenuClick(e, tagKey);
                                      }}
                                      className='showpopupInner'
                                    >
                                      <MoreHoriz className='showpopupInner' />
                                    </Button>
                                  )}
                                  <Menu
                                    id={tagKey.id}
                                    anchorEl={selectedValue?.anchorEl}
                                    disableRestoreFocus
                                    MenuListProps={{ autoFocusItem: false }}
                                    keepMounted
                                    open={
                                      Boolean(selectedValue.anchorEl) &&
                                      selectedValue.id === tagKey.id
                                    }
                                    onClose={handleClose}
                                    className='shadow'
                                  >
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => {
                                        onToggleStatus(e);
                                      }}
                                    >
                                      {selectedValue.tag && selectedValue.tag.status ? (
                                        <>
                                          <RemoveCircleIcon className='me-2 action-menu-icon' />
                                          Deactivate
                                        </>
                                      ) : (
                                        <>
                                          <AddCircle className='me-2 action-menu-icon' />
                                          Activate
                                        </>
                                      )}
                                    </MenuItem>
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => {
                                        onOpenDrawer(e, IN_ROOM_DINING_TAGS_EDIT);
                                      }}
                                    >
                                      <CreateIcon className='me-2 action-menu-icon' />
                                      Edit
                                    </MenuItem>
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => onViewDetails(tagKey, e)}
                                    >
                                      <VisibilityIcon className='me-2 action-menu-icon' />
                                      View
                                    </MenuItem>
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => {
                                        onClickDelete(e);
                                      }}
                                    >
                                      <DeleteForeverIcon className='me-2 action-menu-icon' />
                                      Delete
                                    </MenuItem>
                                  </Menu>
                                </TableCell>
                              </TableRow>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </TableBody>
                    )}
                  </Droppable>
                </DragDropContext>
                <TableFooter>
                  <TableRow className='paginator'>
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                      count={tagsList.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      SelectProps={{
                        inputProps: { 'aria-label': 'rows per page' },
                        native: true,
                      }}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      ActionsComponent={TablePaginationActions}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          )
        )}
        {showMultipleDeleteConfirmation && (
          <MultipleDeleteConfirmationPopup
            title={`Are you sure you want to ${actionName} this selection?`}
            subTitle={`A selection of ${selectedTagsLength} ${
              selectedTagsLength > 1 ? 'tags' : 'tag'
            } will be ${actionName}d. This Action is irreversible.`}
            isOpen={showMultipleDeleteConfirmation}
            onClose={() => setShowMultipleDeleteConfirmation(false)}
            onConfirm={() => {
              deleteMultipleSelection();
            }}
            leftButtonName={'Cancel'}
            rightButtonName={'Delete'}
          />
        )}
        {showBulkActiveDeactiveConfirmation && (
          <MultipleDeleteConfirmationPopup
            title={`Are you sure you want to ${actionName} this selection?`}
            subTitle={`A selection of ${selectedTagsLength}  ${
              selectedTagsLength > 1 ? 'tags' : 'tag'
            } will be ${actionName}d.`}
            isOpen={showBulkActiveDeactiveConfirmation}
            onClose={() => setShowBulkActiveDeactiveConfirmation(false)}
            onConfirm={() => {
              handleMultipleStatusChange();
            }}
            leftButtonName={'No'}
            rightButtonName={'Yes'}
          />
        )}{' '}
        {showBulkSearchAlert && (
          <MultipleSelectionAlert
            isOpen={showBulkSearchAlert}
            onClose={handleBulkSearchAlertClose}
            message="If you perform a search after making selections, the items you've selected will be lost."
            ButtonName='Cancel'
          />
        )}
        {showBulkKebabSelectionAlert && (
          <MultipleSelectionAlert
            isOpen={showBulkKebabSelectionAlert}
            onClose={() => setShowBulkKebabSelectionAlert(false)}
            message='Please select one item from the list that you want to edit.'
            centerButtonName='OK'
          />
        )}
      </div>
    </div>
  );
};

export default TagsListView;
